import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuBrand, BambuBrandUIConfig } from '../interfaces/brands';

/**
 * Gets the brand for the provided brandId.
 */
export class GetBrand extends Executable<BambuBrand> {
  /**
   * The brandId of the brand to retrieve.
   */
  public brandId?: number;

  public getMethod(): Method {
    return 'get';
  }

  public getResponse(apiResponse: any): BambuBrand {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    return `/${this.brandId}`;
  }

  constructor(brandId: number) {
    super();
    this.brandId = brandId;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): undefined {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
